import React, { useState, useEffect } from 'react';
import { useAuthProvider } from "./../../Auth/hooks/useAuthProvider";
import {
    Button, Form, Grid, theme, Typography,
    DatePicker,
    TimePicker,
    Switch,
} from "antd";
const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Text, Title } = Typography;
type SizeType = Parameters<typeof Form>[0]['size'];
const AppointmentSchedule = () => {
    const { initAuth, isSessionAuthenticated } = useAuthProvider();
    const isAuthenticated = isSessionAuthenticated();
    console.log(isAuthenticated);
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const { token } = useToken();
    const screens = useBreakpoint();
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };
    const styles = {
        container: {
            margin: "0 auto",
            padding: screens.md ? `${token.paddingXL}px` : `${token.sizeXXL}px ${token.padding}px`,
            width: "380px"
        },
        footer: {
            marginTop: token.marginLG,
            textAlign: "center",
            width: "100%"
        },
        forgotPassword: {
            float: "right"
        },
        header: {
            marginBottom: token.marginXL
        },
        section: {
            alignItems: "center",
            backgroundColor: token.colorBgContainer,
            display: "flex",
            padding: screens.md ? `${token.sizeXXL}px 0px` : "0px"
        },
        text: {
            color: token.colorTextSecondary
        },
        title: {
            fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3
        }
    };

    useEffect(() => {
        console.log(isAuthenticated);
    }, [isAuthenticated])
    return (
        <section style={styles.section}>
            <div style={styles.container}>
                <div style={styles.header}>


                    <Title style={styles.title}>Schedule Appointment</Title>
                    <Text style={styles.text}>
                        Form to schedule a appointment with healthcare provider
                    </Text>
                </div>
                <Form
                    labelCol={{ span: 12 }}
                    wrapperCol={{ span: 24 }}
                    layout="horizontal"
                    initialValues={{ size: componentSize }}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                    style={{ maxWidth: 800, textAlign: 'left', alignItems: 'left' }}
                    data-testid="appintment-form"

                >
                    <Form.Item label="Appointment Date">
                        <DatePicker data-testid="appintment-datepicker" />
                    </Form.Item>
                    <Form.Item label="Appointment Time">
                        <TimePicker data-testid="appointment-timepicker" />
                    </Form.Item>
                    <Form.Item label="Schedule later" valuePropName="checked">
                        <Switch data-testid="appintment-switch" />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: "0px" }}>
                        <Button id='appointment-schedule-btn' block={true} type="primary" htmlType="submit">
                            Schedule
                        </Button>

                    </Form.Item>
                </Form>
            </div>
        </section>
    )
}
export default AppointmentSchedule